export enum IsActiveResponses {
  DEFAULT,
  NEXT,
  LIMIT,
}
